<button
	(click)="onManageVariantsClick()"
	shape="round"
	size="small"
	nbButton
	status="info"
	outline
>
	<nb-icon status="primary" icon="list-outline"></nb-icon>
	{{ 'INVENTORY_PAGE.MANAGE_VARIANTS_QUANTITY' | translate }}
</button>
